import React, { useEffect, useState } from "react";
import { Button, Card, Popconfirm, Table, Typography, message, Space } from "antd";
import type { ColumnsType } from "antd/es/table";
import { listChecklists, ChecklistRecord, deleteChecklist } from "./api";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;

const Home: React.FC = () => {
  const [data, setData] = useState<ChecklistRecord[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const load = () => {
    setLoading(true);
    listChecklists(10)
      .then((items) => setData(items))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  const columns: ColumnsType<ChecklistRecord> = [
    {
      title: "Дата",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (value: string) => new Date(value).toISOString().slice(0, 16).replace("T", " "),
    },
    {
      title: "Наименование",
      dataIndex: "title",
      key: "title",
      render: (value: string) => <Text>{value}</Text>,
    },
    {
      title: "Автор",
      dataIndex: "author",
      key: "author",
      render: (value: string) => <Text>{value}</Text>,
    },
    {
      title: "",
      key: "action",
      render: (_value, record) => (
        <Space>
          <Button onClick={() => navigate(`/checklist/${record._id}`)}>Перейти</Button>
          <Popconfirm
            title="Удалить чеклист?"
            okText="Удалить"
            cancelText="Отмена"
            onConfirm={async () => {
              try {
                await deleteChecklist(record._id);
                message.success('Удалено');
                load();
              } catch (e) {
                message.error('Не удалось удалить');
              }
            }}
          >
            <Button danger>Удалить</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ maxWidth: 1000, margin: "auto", padding: 20 }}>
      <Card
        title="История чеклистов"
        extra={<Button type="primary" onClick={() => navigate("/checklist/new")}>Новый чеклист</Button>}
      >
        <Table
          rowKey="_id"
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={false}
        />
      </Card>
    </div>
  );
};

export default Home;


